<template>
  <el-container class="home-container">
    <el-header class="home-header">
      <img src="@/assets/images/logo.png" alt="">
      <span>出货管理系统</span>
      <span @click="toggleNav('出货记录')" :class="{active: showShipment}" style="font-size:14px;cursor:pointer;">出货记录</span>
      <span @click="toggleNav('物料单列表')" :class="{active: !showShipment}" style="font-size:14px;cursor:pointer;">物料单列表</span>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{nickName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="unlogin">退出</span>
          </el-dropdown-item>
           <el-dropdown-item>
            <span @click="restPassword">修改密码</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <el-main>
        <el-card v-if="showShipment" shadow="never" class="box-card">
          <div class="add-client-wrap">
            <div class="title">出货记录</div>
            <!-- <el-button style="margin-left:10px;" icon="el-icon-circle-plus-outline" @click="addShipmentDialog" plain size="small" type="primary">新增出货</el-button> -->
            <el-button icon="el-icon-circle-close-outline" @click="removeShipmentDialog" plain size="small" type="warning">回收SN</el-button>
          </div>
          <div class="filter-list-wrap">
            <span>筛选条件：</span>
            <el-date-picker
              v-model="filterTimestamp"
              align="right"
              type="date"
              placeholder="选择日期"
              value-format="timestamp"
              :picker-options="pickerOptions1">
            </el-date-picker>
            <el-input
              style="width:200px;"
              placeholder="输入出货备注"
              v-model="remark"
              clearable>
            </el-input>
            <el-button style="margin-left:10px;" @click="searchBtn" icon="el-icon-search" type="primary">搜索</el-button>
          </div>
          <div class="table-wrap">
            <el-table
              :data="listData"
              stripe>
              <el-table-column
                label="物料单号">
                <template slot-scope="scope">
                  <span v-if="scope.row.moNumber=='reshipment'">回收</span>
                  <span v-else>{{scope.row.moNumber||'--'}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="fileName"
                label="文件名">
              </el-table-column>
              <el-table-column
                prop="productName"
                width="250"
                label="产品名称">
                <template slot-scope="scope">
                  <span v-if="scope.row.tag">【{{scope.row.tag}}】</span>
                  <span>{{scope.row.productName}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="productNumber"
                label="产品编号">
              </el-table-column>
              <el-table-column
                prop="productModelName"
                label="款式名称">
              </el-table-column>
              <el-table-column
                prop="createdAt"
                label="出货时间">
                <template slot-scope="scope">
                  {{scope.row.createdAt | time}}
                </template>
              </el-table-column>
              <el-table-column
                prop="createdBy"
                label="出货人员">
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <!-- <el-button @click="editDetail(scope.row.id)" type="text" size="small">重新出货</el-button> -->
                  <el-button @click="exportMoteExcel(scope.row.id)" type="text" size="small">导出</el-button>
                  <el-button @click="getShipmentDetail(scope.row.id)" type="text" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table-page-wrap">
            <el-pagination
              @current-change="currentChange"
              :current-page="currentPage"
              layout="total, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </el-card>
        <materialList v-else/>
        <!-- 新增出货 -->
        <el-dialog
          :title="dialogTitle"
          :close-on-click-modal="false"
          :visible.sync="shipmentDialog"
          :before-close="closeDialog"
          width="400px">
          点击
          <a style="color: #409EFF;" href="http://imgs.creekspring.com/ignis-shipment-tempate.zip" target="_blank">[下载模板]</a>
          <el-upload
            class="upload-demo"
            ref="upload"
            drag
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :data="shipmentData"
            :action="uploadUrl"
            :headers="headers"
            :auto-upload="false"
            :on-change="uploadPreview"
            :limit="1"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <div v-if="dialogTitle === '新增出货'" class="sub-system-wrap">
            <el-cascader
              v-model="systemSelected"
              clearable
              filterable
              placeholder="请选择子系统"
              expand-trigger="hover"
              :options="systemListSelect"
              @change="systemListhandleChange">
            </el-cascader>
            <el-cascader
              v-if="this.systemType==2"
              clearable
              filterable
              placeholder="请选择产品型号"
              expand-trigger="hover"
              :options="productModelOptions"
              @change="productModelIdhandleChange">
            </el-cascader>
            <el-input
              type="number"
              min="0"
              max="29"
              v-if="this.systemType==2"
              style="margin-bottom: 8px;"
              placeholder="配电柜支路数，不是配电柜可不填"
              v-model="shipmentData.branchNum">
            </el-input>
            <el-input
              type="number"
              min="0"
              max="6"
              v-if="this.systemType==2"
              style="margin-bottom: 8px;"
              placeholder="配电柜防盗主机数，不是配电柜可不填"
              v-model="shipmentData.mainTheftPreventionNum">
            </el-input>
          </div>
          <el-input
            placeholder="请输入备注内容"
            v-model="shipmentData.remark"
            clearable>
          </el-input>
          <el-button style="margin-top: 8px;" size="small" type="success" @click="submitUpload">上传文件</el-button>
        </el-dialog>
        <!-- 重新出货 -->
        <el-dialog
          title="重新出货"
          :close-on-click-modal="false"
          :visible.sync="reshipmentDialog"
          :before-close="closeDialog"
          width="400px">
          <el-cascader
            v-model="systemSelected"
            clearable
            filterable
            placeholder="请选择子系统"
            expand-trigger="hover"
            :options="systemListSelect"
            @change="systemListhandleChange">
          </el-cascader>
          <el-cascader
            v-if="this.systemType==2"
            clearable
            filterable
            placeholder="请选择产品型号"
            expand-trigger="hover"
            :options="productModelOptions"
            @change="productModelIdhandleChange">
          </el-cascader>
          <el-input
            type="number"
            min="0"
            max="29"
            v-if="this.systemType==2"
            style="margin-bottom: 8px;"
            placeholder="配电柜支路数，不是配电柜可不填"
            v-model="shipmentData.branchNum">
          </el-input>
          <el-input
            type="number"
            min="0"
            max="6"
            v-if="this.systemType==2"
            style="margin-bottom: 8px;"
            placeholder="配电柜防盗主机数，不是配电柜可不填"
            v-model="shipmentData.mainTheftPreventionNum">
          </el-input>
          <el-input
            placeholder="请输入备注内容"
            v-model="shipmentData.remark"
            clearable>
          </el-input>
          <el-button style="margin-top: 8px;" size="small" type="success" @click="reshipment">重新出货</el-button>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog
          title="出货详情"
          :close-on-click-modal="false"
          :visible.sync="detailDialog">
          <detail ref="detailList" :id="itemId" :systemList="systemList" :detailDialog="detailDialog"></detail>
        </el-dialog>
        <!-- 出货结果反馈 -->
        <el-dialog
          title="出货错误反馈"
          width="700px"
          :close-on-click-modal="false"
          :visible.sync="importResultDialog">
          <importResult :taskImportResult="taskImportResult"></importResult>
        </el-dialog>
        <!-- 修改密码 -->
        <el-dialog
          title="修改密码"
          :visible.sync="resetPasswordDialog"
          :close-on-click-modal="false"
          width="30%">
          <el-form label-width="80px">
            <el-form-item label="旧密码">
              <el-input type="password" v-model.trim="password.old"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input type="password" v-model.trim="password.new"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
              <el-input type="password" v-model.trim="password.confirm"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetPasswordBtn" type="success">确认修改</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-main>
    </el-container>
    <el-footer class="home-footer">©Coyperight2016-2018华泉出货管理系统</el-footer>
  </el-container>
</template>

<script>
import '@/assets/stylus/home.styl';
import http from 'http';
import detail from './child/detail';
import importResult from './child/importResult';
import materialList from './materialList';

export default {
  components: {
    detail,
    importResult,
    materialList
  },
  data () {
    return {
      showShipment: true,
      fileLength: 0,
      password: {
        old: '',
        new: '',
        confirm: ''
      },
      shipmentData: {
        remark: '',
        systemId: '',
        productId: 0,
        productModelId: 0,
        branchNum: 0,
        mainTheftPreventionNum: 0
      },
      systemSelected: [],
      itemId: '',
      remark: '',
      dialogTitle: '',
      taskImportResult: {},
      importResultDialog: false,
      resetPasswordDialog: false,
      reshipmentDialog: false,
      detailDialog: false,
      shipmentDialog: false,
      filterTimestamp: null,
      filterSystemId: '',
      systemList: [],
      systemListSelect: [],
      systemType: 1,
      productModelOptions: [],
      systemId: '',
      nickName: '',
      username: '',
      tableData: {
        records: []
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }
    };
  },
  computed: {
    headers () {
      return {
        'Authorization': `Bearer ${this.$store.state.login.token}`
      };
    },
    uploadUrl () {
      return `/api/v1/device-sns/shipment`;
    },
    listData () {
      let res = this.tableData.records.map(item => {
        this.systemList.forEach(subItem => {
          if (item.systemId === subItem.id) item['systemName'] = subItem.name;
          if (item.systemId === 0) item['systemName'] = '回收SN操作';
        });
        return item;
      });
      return res;
    },
    currentPage () {
      return this.tableData.pageNo || 1;
    },
    pageSize () {
      return this.tableData.pageSize || 10;
    },
    total () {
      return this.tableData.recordCount;
    }
  },
  methods: {
    systemListFilterChange (val) {
      this.filterSystemId = val[1];
    },
    systemListhandleChange (val) {
      this.systemType = val[0];
      if (val[1] === 36) {
        this.shipmentData.systemId = 1;
      } else {
        this.shipmentData.systemId = val[1];
      }
    },
    // 选择出货的产品
    productModelIdhandleChange (val) {
      this.shipmentData.productId = val[0];
      this.shipmentData.productModelId = val[1];
    },
    async reshipment () {
      if (this.systemSelected.length !== 2) {
        this.$notify({
          title: '警告',
          message: `请选择子系统`,
          type: 'warning'
        });
        return false;
      }
      let { data } = await http.post(`/v1/device-sns/reshipment`, {
        id: this.itemId,
        systemId: this.shipmentData.systemId,
        remark: this.shipmentData.remark,
        productModelId: this.shipmentData.productModelId,
        productId: this.shipmentData.productId,
        branchNum: this.shipmentData.branchNum,
        mainTheftPreventionNum: this.shipmentData.mainTheftPreventionNum
      });
      if (data.code === 200) {
        this.$notify({
          title: '成功',
          message: '操作成功',
          type: 'success'
        });
        if (data.detail !== undefined) {
          this.importResultDialog = true;
          this.taskImportResult = data.detail;
        }
      } else {
        this.$notify({
          title: '错误',
          message: `操作失败`,
          type: 'error'
        });
      }
      this.resetFormData();
      this.updateList();
      this.reshipmentDialog = false;
    },
    editDetail (id) {
      this.itemId = id;
      this.reshipmentDialog = true;
    },
    resetFormData () {
      this.shipmentData.systemId = '';
      this.shipmentData.remark = '';
      this.shipmentData.productModelId = 0;
      this.shipmentData.productId = 0;
      this.shipmentData.branchNum = 0;
      this.shipmentData.mainTheftPreventionNum = 0;
      this.systemType = 1;
      this.systemSelected = [];
      try {
        this.$refs.upload.clearFiles();
      } catch (e) {}
    },
    closeDialog (done) {
      this.resetFormData();
      done();
    },
    uploadError (response) {
      try {
        let result = JSON.parse(String(response).substring(7, String(response).length));
        if (result.success === false) {
          this.$notify({
            title: '错误',
            message: `${result.message}`,
            type: 'error'
          });
        }
        if (result.detail !== undefined) {
          this.importResultDialog = true;
          this.taskImportResult = result.detail;
        }
      } catch (e) {
        this.$notify({
          title: '错误',
          message: `未知错误，请联系管理员`,
          type: 'error'
        });
      }
    },
    uploadSuccess (response, file, fileList) {
      this.$notify({
        title: '成功',
        message: '操作成功',
        type: 'success'
      });
      this.updateList();
      this.resetFormData();
      this.shipmentDialog = false;
      console.log(response);
      if (response.detail !== undefined) {
        this.importResultDialog = true;
        this.importResult = response.detail;
      }
    },
    addShipmentDialog () {
      this.shipmentDialog = true;
      this.dialogTitle = '新增出货';
    },
    removeShipmentDialog () {
      this.shipmentDialog = true;
      this.shipmentData.systemId = 0;
      this.shipmentData.productModelId = 0;
      this.shipmentData.productId = 0;
      this.dialogTitle = '回收SN';
    },
    uploadPreview (file, fileList) {
      this.fileLength = fileList.length;
    },
    submitUpload () {
      if (this.shipmentData.systemId !== '') {
        if (this.fileLength !== 0) {
          this.$refs.upload.submit();
        } else {
          this.$notify({
            title: '警告',
            message: '请先上传文件',
            type: 'warning'
          });
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请选择子系统',
          type: 'warning'
        });
      }
    },
    // 导出excel
    async exportMoteExcel (id) {
      let { data } = await http.post(`/v1/shipment-logs/export-mote-excel/${id}`);
      open(`http://${data}`);
    },
    currentChange (val) {
      // 发送请求
      this.tableData.pageNo = val;
      this.updateList(val, 10);
    },
    // 搜索
    searchBtn () {
      this.tableData.pageNo = 1;
      this.updateList();
    },
    // 更新出货列表
    async updateList () {
      let result = {};
      if (this.filterSystemId === undefined) this.filterSystemId = '';
      if (this.filterTimestamp === null && this.filterSystemId !== '') {
        result = await http.get(`/v1/shipment-logs?pageNo=${this.currentPage}&pageSize=${10}&systemId=${this.filterSystemId}&remark=${this.remark}`);
      }
      if (this.filterTimestamp !== null && this.filterSystemId === '') {
        result = await http.get(`/v1/shipment-logs?pageNo=${this.currentPage}&pageSize=${10}&createdAt=${this.filterTimestamp}&remark=${this.remark}`);
      }
      if (this.filterTimestamp !== null && this.filterSystemId !== '') {
        result = await http.get(`/v1/shipment-logs?pageNo=${this.currentPage}&pageSize=${10}&createdAt=${this.filterTimestamp}&systemId=${this.filterSystemId}&remark=${this.remark}`);
      }
      if (this.filterTimestamp === null && this.filterSystemId === '') {
        result = await http.get(`/v1/shipment-logs?pageNo=${this.currentPage}&pageSize=${10}&remark=${this.remark}`);
      }
      this.tableData = result.data;
    },
    // 获取子系统
    async getSystemList () {
      let { data } = await http.get('/v1/sub-systems');
      this.systemList = data;
      let solorList = this.systemList.filter(item => item.systemType === 1).map(item => {
        return {
          value: item.id,
          label: item.name
        };
      });
      let smartGridList = this.systemList.filter(item => item.systemType === 2).filter(item => item.id !== 38).map(item => {
        return {
          value: item.id,
          label: item.name
        };
      });
      this.systemListSelect = [
        {
          value: 1,
          label: '太阳能',
          children: solorList
        },
        {
          value: 2,
          label: '市电',
          children: smartGridList
        }
      ];
    },
    // 获取款式列表
    async getProductModel () {
      let { data } = await http.get('/v1/product-model/list-product-and-model');
      this.productModelOptions = data.filter(item => {
        if (item.productModels !== undefined) {
          return item;
        }
      }).map(item => {
        return {
          value: item.productId,
          label: (item.tag ? `【${item.tag}】` : '') + item.productName,
          children: item.productModels.map(subItem => {
            return {
              value: subItem.id,
              label: subItem.modelName
            };
          })
        };
      });
    },
    // 退出登录
    unlogin () {
      this.$store.commit('updateToken', '');
      sessionStorage.clear();
      this.$router.push({name: 'login'});
    },
    // 获取出货详情
    async getShipmentDetail (id) {
      this.itemId = id;
      this.detailDialog = true;
    },
    async resetPasswordBtn () {
      if (this.password.new.length < 6 || this.password.new.length > 16) {
        this.$message({
          message: '密码长度为6-16个字符',
          type: 'warning'
        });
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.$message({
          message: '两次输入的新密码不同',
          type: 'warning'
        });
        return false;
      }
      let { data } = await http.post(`/v1/me/password`, {
        oldPassword: this.password.old,
        newPassword: this.password.new
      });
      if (data.success === true) {
        this.$message({
          message: '密码修改成功',
          type: 'success'
        });
        this.resetPasswordDialog = false;
        this.$router.push({name: 'login'});
      }
    },
    restPassword () {
      this.resetPasswordDialog = true;
    },
    toggleNav (type) {
      if (type === '出货记录') {
        this.updateList(1, 10);
        this.showShipment = true;
      } else {
        this.showShipment = false;
      }
    }
  },
  async created () {
    // 获取用户列表
    this.updateList(1, 10);
    this.getSystemList();
    this.getProductModel();
    try {
      this.nickName = JSON.parse(sessionStorage.getItem('userInfo')).nickname || '华泉智能';
      this.username = JSON.parse(sessionStorage.getItem('userInfo')).username || '';
    } catch (e) {
    }
  }
};
</script>

<style scoped>
.el-dialog .el-cascader {
  margin-bottom: 7px;
  width: 100%;
}
.home-header .active {
  color: orangered;
}
</style>



// WEBPACK FOOTER //
// src/views/shipment/index.vue